<template>
    <div class="main-sidebar">
        <aside id="sidebar-wrapper">
          <div class="sidebar-brand">
            <a href="index.html"><img src="src/assets/img/logo-efi.png" width="100px" alt="EFI"></a>
          </div>
          <div class="sidebar-brand sidebar-brand-sm">
            <a href="index.html">EFI</a>
          </div>
          <ul class="sidebar-menu">
              <li v-show="menus.dashboardMenu" class="menu-header">Dashboard & Laporan</li>
              <li v-show="menus.dashboard" v-bind:class="{ active: isActive == 'dashboard' }"><a class="nav-link" @click="goTo('/dashboard')"><i class="fas fa-fire"></i> <span>Dashboard</span></a></li>
              <li v-show="menus.laporan" class="dropdown">
                <a href="#" ref="laporan" class="nav-link has-dropdown" data-toggle="dropdown"><i class="fas fa-bar-chart"></i> <span>Laporan</span></a>
                <ul class="dropdown-menu">
                  <li><a class="nav-link" @click="goTo('/laporan/pembelian/daftar-pembelian','laporan')">Pembelian</a></li>
                  <li><a class="nav-link" @click="goTo('/laporan/penjualan/daftar-penjualan','laporan')">Penjualan</a></li>
                  <li><a class="nav-link" @click="goTo('/laporan/produk/daftar-produk','laporan')">Produk</a></li>
                </ul>
              </li>
              <li v-show="menus.stocking" class="menu-header">Stocking</li>
              <li v-show="menus.produk" class="dropdown">
                <a href="#" ref="produkMenu" class="nav-link has-dropdown" data-toggle="dropdown"><i class="fas fa-cube"></i> <span>Produk</span></a>
                <ul class="dropdown-menu">
                  <li><a class="nav-link" @click="goTo('/produk/daftar-produk','produkMenu')">Daftar Produk</a></li>
                  <li><a class="nav-link" @click="goTo('/produk/transfer-gudang','produkMenu')">Transfer Gudang</a></li>
                </ul>
              </li>
              <li v-show="menus.pembelian" class="dropdown">
                <a href="#" ref="pembelianMenu" class="nav-link has-dropdown"><i class="fas fa-th-large"></i> <span>Pembelian</span></a>
                <ul class="dropdown-menu">
                  <li><a class="nav-link" @click="goTo('/pembelian/list/pemesanan-pembelian','pembelianMenu')">Pemesanan Pembelian</a></li>
                  <li><a class="nav-link" @click="goTo('/pembelian/list/packing-pembelian','pembelianMenu')">Packing Pembelian</a></li>
                  <li><a class="nav-link" @click="goTo('/pembelian/list/pengiriman-pembelian','pembelianMenu')">Pengiriman Pembelian</a></li>
                  <li><a class="nav-link" @click="goTo('/pembelian/list/faktur-pembelian','pembelianMenu')">Faktur Pembelian</a></li>
                  <li><a class="nav-link" @click="goTo('/pembelian/list/pembayaran-pembelian','pembelianMenu')">Pembayaran Pembelian</a></li>
                  <li><a class="nav-link" @click="goTo('/pembelian/list/selesai-pembelian','pembelianMenu')">Selesai Pembelian</a></li>
                </ul>
              </li>
              <li v-show="menus.penjualan" class="dropdown">
                <a href="#" ref="penjualanMenu" class="nav-link has-dropdown"><i class="fas fa-dollar"></i> <span>Penjualan</span></a>
                <ul class="dropdown-menu">
                  <li><a class="nav-link" @click="goTo('/penjualan/list/pemesanan-penjualan','penjualanMenu')">Pemesanan Penjualan</a></li>
                  <li><a class="nav-link" @click="goTo('/penjualan/list/packing-penjualan','penjualanMenu')">Packing Penjualan</a></li>
                  <li><a class="nav-link" @click="goTo('/penjualan/list/pengiriman-penjualan','penjualanMenu')">Pengiriman Penjualan</a></li>
                  <li><a class="nav-link" @click="goTo('/penjualan/list/faktur-penjualan','penjualanMenu')">Faktur Penjualan</a></li>
                  <li><a class="nav-link" @click="goTo('/penjualan/list/pembayaran-penjualan','penjualanMenu')">Pembayaran Penjualan</a></li>
                  <li><a class="nav-link" @click="goTo('/penjualan/list/selesai-penjualan','penjualanMenu')">Selesai Penjualan</a></li>
                </ul>
              </li>
              <li v-show="menus.produksi" class="dropdown">
                <a href="#" ref="produksiMenu" class="nav-link has-dropdown"><i class="fas fa-atom"></i> <span>Produksi</span></a>
                <ul class="dropdown-menu">
                  <!-- <li><a class="nav-link" @click="goTo('/produk/produksi','produksiMenu')">Produksi</a></li> -->
                  <li><a class="nav-link" @click="goTo('/produk/history-produksi','produksiMenu')">History Produksi</a></li>
                </ul>
              </li>
              <li v-show="menus.pembiayaan" class="menu-header">Pembiayaan</li>
              <!-- <li v-show="menus.pembiayaan"><a class="nav-link" @click="goTo('/pembiayaan/pengiriman')"><i class="fas fa-truck"></i> <span>Pengiriman</span></a></li> -->
              <li v-show="menus.pembiayaan"><a class="nav-link" @click="goTo('/pembiayaan/list')"><i class="fa fa-money"></i> <span>Biaya Lain-Lain</span></a></li>
              <li v-show="menus.finance" class="menu-header">Finance</li>
              <li v-show="menus.finance"><a class="nav-link" @click="goTo('/finance/daftar-akun')"><i class="fas fa-book"></i> <span>Daftar Akun</span></a></li>
              <li v-show="menus.finance"><a class="nav-link" @click="goTo('/finance/neraca')"><i class="fas fa-bar-chart"></i> <span>Laporan Neraca</span></a></li>
              <li v-show="menus.finance"><a class="nav-link" @click="goTo('/finance/laba-rugi')"><i class="fas fa-bar-chart"></i> <span>Laporan Laba Rugi</span></a></li>
              <li v-show="menus.setting" class="menu-header">Settings & Master</li>
              <li v-show="menus.setting" class="dropdown">
                <a href="#" class="nav-link has-dropdown"><i class="fas fa-cogs"></i> <span>Settings</span></a>
                <ul class="dropdown-menu">
                  <!-- <li><a class="nav-link" @click="goTo('/settings/perusahaan')">Perusahaan</a></li> -->
                  <li><a class="nav-link" @click="goTo('/settings/user')">User Management</a></li>
                  <li><a class="nav-link" @click="goTo('/settings/pemetaan-akun')">Pemetaan Akun</a></li>
                  <!-- <li><a class="nav-link" @click="goTo('/settings/nomor-transaksi')">ID/Nomor Transaksi</a></li> -->
                </ul>
              </li>
              <li v-show="menus.setting" class="dropdown">
                <a href="#" class="nav-link has-dropdown"><i class="fas fa-database"></i> <span>Master</span></a>
                <ul class="dropdown-menu">
                  <li><a class="nav-link" @click="goTo('/master/gudang')">Gudang</a></li>
                  <li><a class="nav-link" @click="goTo('/master/shipping')">Shipping</a></li>
                  <li><a class="nav-link" @click="goTo('/master/kontak-pelanggan')">Kontak Pelanggan</a></li>
                  <li><a class="nav-link" @click="goTo('/master/kontak-supplier')">Kontak Supplier</a></li>
                  <li><a class="nav-link" @click="goTo('/master/kontak-karyawan')">Kontak Karyawan</a></li>
                  <!-- <li><a class="nav-link" @click="goTo('/master/pajak')">Pajak</a></li> -->
                </ul>
              </li>
              
            </ul>

            <!-- <div class="mt-4 mb-4 p-3 hide-sidebar-mini">
              <a href="https://getstisla.com/docs" class="btn btn-primary btn-lg btn-block btn-icon-split">
                <i class="fas fa-rocket"></i> Documentation
              </a>
            </div> -->
        </aside>
      </div>
</template>
<script>
import router from '../../router/index.js';
export default {
    data() {
        return {
            isActive: '',
        }
    },
    props: ['show','menus'],
    mounted: function(){
        this.isActive = this.$route.path;
    },
    methods: {
        
        goTo(path,refss){
            // var style = this.$refs.produkMenu[0].style.display
            // console.log(style)
            this.$router.replace({ path : path })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        }    
    }
}

</script>



// WEBPACK FOOTER //
// src/components/template/Sidebar.vue